import { FaFacebook, FaWhatsapp } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { LuLinkedin } from "react-icons/lu";
import { MdEmail } from "react-icons/md";
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";

export const LIST_OF_SOCIALS =[
    {
        Button : EmailShareButton,
        props : {
            subject : "Posted Job Link"
        },
        Icon : MdEmail
    },
    {
        Button : TwitterShareButton,
        props : {},
        Icon : FaXTwitter
    },
    {
        Button : FacebookShareButton,
        props : {},
        Icon : FaFacebook,
    },
    {
        Button : WhatsappShareButton,
        props : {},
        Icon : FaWhatsapp
    },
    {
        Button : LinkedinShareButton,
        props : {
            title :"Posted Job Link"
        },
        Icon : LuLinkedin
    }
]